import { useId } from 'react';

import CloseIcon from '../../icons/close';
import SearchIcon from '../../icons/search';

import './styles/search-field.css';

export default function SearchField({ label, value, onChange, placeholder }) {
    const id = useId();
    return (
        <div className="search-field">
            <label htmlFor={id} className="visually-hidden">{label}</label>
            <SearchIcon className="search-field__icon" size={18} />
            <input
                id={id}
                className="search-field__input"
                type="search"
                inputMode="search"
                autoComplete="off"
                enterKeyHint="search"
                value={value}
                placeholder={placeholder}
                onChange={(event) => onChange(event.target.value)}
            />
            {value && (
                <button type="button" className="search-field__clear" onClick={() => onChange('')}>
                    <CloseIcon size={16} />
                    <span className="visually-hidden">Borrar búsqueda</span>
                </button>
            )}
        </div>
    );
}
